<template>
    <div class="p-4">
        <h2 class="mb-4">Création d'un utilisateur</h2>
        
        <div v-if="error.length" class="alert alert-danger" role="alert">
        {{ error }}
        </div>

        <form @submit="sendForm" method="POST" >
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="inputEmail4">Prénom</label>
                    <input v-model="givenName" type="text" class="form-control" id="givenName" placeholder="Prénom" required>
                </div>
                <div class="form-group col-md-6">
                    <label for="inputPassword4">Nom</label>
                    <input v-model="sn" type="text" class="form-control" id="sn" placeholder="Nom" required>
                </div>
            </div>
            <div class="form-group">
                <label for="inputAddress">Email</label>
                <input v-model="mail" type="email" class="form-control" id="mail" placeholder="Email" required>
            </div>
            <div class="form-group">
                <label for="inputAddress">Mot de passe</label>
                <input v-model="mdp" type="password" class="form-control" id="mdp" placeholder="Mot de passe" required>
            </div>
            
            <button type="submit" class="btn btn-primary">Créer</button>
        </form>
    </div>
</template>

<script>
import conf from '../../../../config/api';
    export default {
        data() {
            return {
                conf: conf,
                error: ""
            }
        },
        methods: {
            sendForm: function(e) { // Fonction qui envoie le formulaire
                e.preventDefault(); // On empêche le comportement par défaut du navigateur, c'est à dire de soumettre le formulaire
                
                this.axios.post(`${conf.server}/api/ldap/user/add`, { // On fait une requête axios en POST vers l'API contenant le formulaire
                    givenName: this.givenName,
                    sn: this.sn,
                    mail: this.mail,
                    password: this.mdp
                })
                .then((response) => { // En cas de succès
                    this.error = "" // On vide le message d'erreur
                    console.log(response)
                    window.location.href = `${conf.server}/gestion-user` // On redirige l'utilisateur vers la page de gestion des utilisateurs
                })
                .catch((err) => {
                    console.log(err.response.data.message) // On affiche le message d'erreur dans la console
                    this.error = err.response.data.message // On ajoute le message d'erreur à la variable error
                })
            }
        }
    }
</script>